import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';
import ThemeConfig from '@config/theme';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formProducerSignup_formContainer: {

		},
		formProducerSignup_header: {
			backgroundColor: ThemeConfig.primaryColor,
			color: ThemeConfig.primaryContrastTextColor,
			padding: theme.spacing(1, 0),
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
		},
		formProducerSignup_headerTitle: {
			fontSize: theme.typography.h4.fontSize,
			fontWeight: theme.typography.fontWeightLight,
			margin: theme.spacing(1, 0, 0),
			textAlign: 'center',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
		},
		formProducerSignup_headerSubtitle: {
			fontSize: theme.typography.h6.fontSize,
			fontWeight: theme.typography.fontWeightLight,
			margin: theme.spacing(0, 0, 1),
			textAlign: 'center',
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body1.fontSize,
			},
		},
		formProducerSignup_sectionTitle: {
			color: theme.palette.info.dark,
			textAlign: 'center',
			fontSize: theme.typography.h5.fontSize,
			fontWeight: theme.typography.fontWeightRegular,
			margin: theme.spacing(4),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
		},
		formProducerSignup_agreementContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		formProducerSignup_agreementInstructions: {
			fontSize: theme.typography.body1.fontSize,
			color: theme.palette.info.main,
		},
		formProducerSignup_agreementAcknowledgement: {

		},
	});
});

export default useStyles;
